angular.module('unergie.main')
.factory('ErrorCatcher', (AlertManager, AuthService) => {
    const catchError = function (error) {
        console.error(error)
        if (!error) {
            return
        }
        if (error && error.status === 401) {
            AuthService.logout()
            return AuthService.openLoginModal()
        }
        const msg = _.get(error, 'data.error.message') ||
            _.get(error, 'data.error') ||
            _.get(error, 'data.message') ||
            _.get(error, 'message') ||
            'Erreur inconnue, merci de contacter support.partenaires@plum-energie.com'
        const detail = _.get(error, 'data.detail') || _.get(error, 'data.error.detail')
        return AlertManager.addAlert({
            type: 'error',
            timeout: 5000,
            msg: (_.isObject(msg) ? JSON.stringify(msg) : msg),
            detail,
        })
    }

    return catchError
})
